import { configureStore } from "@reduxjs/toolkit";
import userProfileSlice from "./login_slice";
import panelSliceReducer from "./panel_slice";
import dateTimeSliceReducer from "./datetime_slice";
import summarySliceReducer from "./summary_slice";
import globalErrorSliceReducer from "./error_slice";
import manageFarmerSliceReducer from "./manage_farmer_slice";
import manageSurveyorSliceReducer from "./manage_surveyor_slice";
import subRouteSliceReducer from "./route_slice";
const store = configureStore({
  reducer: {
    userProfileSlice: userProfileSlice,
    panelSlice: panelSliceReducer,
    dateTimeSlice: dateTimeSliceReducer,
    summarySlice: summarySliceReducer,
    globalErrorSlice: globalErrorSliceReducer,
    manage_farmer_slice: manageFarmerSliceReducer,
    manage_surveyor_slice: manageSurveyorSliceReducer,
    subRouteSlice: subRouteSliceReducer,
  },
});

export default store;
